<template>
    <div>
        <div class="top">
            <van-nav-bar title="学校概况" left-text="返回" left-arrow @click-left="onClickLeft"/>
        </div>
        <div class="menu">
            <div :class="currentId === item.id?'menu-item-on':'menu-item-off'" v-for="item in tabs" :key="item.id" @click="selectMenu(item)">{{item.name}}</div>
        </div>
        <div class="content" v-if="currentId === 17">
            <p v-html="mark17"></p>
        </div>
        <div class="content" v-if="currentId === 18">
            <p v-html="mark18"></p>
        </div>
        <div class="content" v-if="currentId === 19">
            <p v-html="mark19"></p>
        </div>
    </div>
</template>

<script>
        import {httpPost,httpGet} from "../../../../axios/index";


    export default {
        name: "schoolInfo",
        data() {
            return {
                currentId:17,
                mark17: [],
                mark18: [],
                mark19: [],
                tabs: []
            }
        },
        methods: {
            onClickLeft() {
                this.$router.go(-1);
            },
            selectMenu(item){
                this.currentId = item.id
            },
            loadInfo() {
                httpPost( 
                   "/saas/lists",
                   {schoolid: this.$route.query.id, mark: 1}
                )
                    .then(response => {
                     
                        if (response.code === 1) {
                            if(response.mark18==undefined){
                                this.mark18="暂无数据"
                            }
                            else{
                                 this.tabs = response.tabs;
                                this.mark17 = response.mark17;
                                this.mark18 = response.mark18;
                                this.mark19 = response.mark19;
                            }
                           
                        }
                    })
            }
        },
        mounted() {
            this.loadInfo();
        }
    }
</script>

<style scoped>
    .menu {
        display: flex;
        font-size: 1.2rem;
        border-bottom: 0.05rem solid #ccc;
    }
    .menu-item-on,.menu-item-off{
        width: 25vw;
        text-align: center;
        padding:0.5rem 0;
    }
    .menu-item-on{
        color: #25BAFD;
    }
    .content{
        padding:0.5rem;
        font-size: 0.8rem;
    }
</style>